import script from "./UserAddModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAddModal.vue?vue&type=script&setup=true&lang=js"

import "./UserAddModal.vue?vue&type=style&index=0&id=28a45480&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a45480"]])

export default __exports__